<template>
  <td :id="'td' + timeId" class="has-text-right is-narrow" :style="`width: ${width};`" v-if="displayDocument && hasButton">
    <button v-if="selectedRow !== index" class="button is-grey is-outlined is-circle is-small" @click="toggleDisplayButtons(index)">
      <span class="icon is-small"><i class="fas fa-ellipsis-h is-size-5"></i></span>
    </button>
    <div v-else class="">
      <button v-if="uploading" disabled="disabled" class="button is-grey is-outlined is-circle is-small is-loading">
        <span class="icon is-small"><i class="fas fa-spinner-third is-size-5"></i></span>
      </button>
      <a v-else-if="document && isPdf" @click="previewDocument"
         class="button is-grey is-outlined is-circle is-small tooltip is-tooltip-top" data-tooltip="Voir le document">
        <span class="icon is-small"><i class="fas fa-eye is-size-5"></i></span>
      </a>
      <a v-else-if="document && !isPdf" :href="target.document.path" target="_blank"
         class="button is-grey is-outlined is-circle is-small tooltip is-tooltip-top" data-tooltip="Voir le document">
        <span class="icon is-small"><i class="fas fa-eye is-size-5"></i></span>
      </a>
      <button v-if="target.document && canRemove && !uploading && (isAdmin || isSectorManager)" @click="removeDocument"
              class="button is-grey is-outlined is-circle is-small tooltip is-tooltip-top" data-tooltip="Supprimer le document">
        <span class="icon is-small"><i class="fas fa-trash is-size-5"></i></span>
      </button>
      <div v-else-if="canUpload && !uploading && (isAdmin || isSectorManager)" class="file">
        <label class="file-label">
          <input class="file-input" type="file" name="resume" @change="processFile($event)">
          <span class="file-cta is-borderless">
              <span class="file-icon button is-grey is-outlined is-circle is-small">
                <span class="icon is-small"><i class="fas fa-cloud-upload is-size-5"></i></span>
              </span>
            </span>
        </label>
      </div>
      <slot></slot>
      <button class="button is-grey is-outlined is-circle is-small" @click="toggleDisplayButtons(null)" v-if="!uploading">
        <span class="icon is-small"><i class="fas fa-times is-size-5"></i></span>
      </button>
    </div>
  </td>
</template>

<script>
  import { mapGetters } from 'vuex'
  import moment from 'moment'

  export default {
    name: 'TableFileRow',
    props: {
      isSlot: {
        type: Boolean,
        required: false,
        default: false
      },
      target: {
        type: Object,
        required: true
      },
      canUpload: {
        type: Boolean,
        required: false,
        default: true
      },
      canRemove: {
        type: Boolean,
        required: false,
        default: true
      },
      index: {
        type: String
      },
      selectedRow: {
        type: String
      },
      width: {
        type: String,
        default: '160px'
      }
    },
    data () {
      return {
        uploading: false,
        timeId: moment().format('YYYYMMDDHHmmssSSS')
      }
    },
    computed: {
      ...mapGetters(['isAdmin']),
      document () {
        return this.target.document
      },
      extension () {
        if (this.document) {
          let fileName = this.document.path
          return fileName.substr(fileName.lastIndexOf('.') + 1)
        }
        return null
      },
      isImage () {
        return this.document && this.extension && ['jpg', 'png', 'gif'].includes(this.extension)
      },
      isPdf () {
        return this.document && this.extension === 'pdf'
      },
      filePath () {
        return this.document.path
      },
      displayDocument () {
        if (this.document) {
          return this.document && (this.isAdmin || this.document.display)
        } else {
          return true
        }
      },
      hasButton () {
        if (!this.isSlot && !this.isAdmin) {
          if (this.document) {
            return this.document && this.displayDocument
          } else {
            return false
          }
        } else {
          return true
        }
      }
    },
    methods: {
      toggleDisplayButtons (idx) {
        this.$emit('selectedRow', idx)
      },
      removeDocument () {
        this.$emit('remove', this.target)
      },
      previewDocument () {
        this.$emit('preview', this.target.document)
      },
      processFile (event) {
        let file = event.target.files[0]
        let files = new FormData()
        files.append('file[]', file, file.name)
        this.uploading = true
        this.$api.uploadService.post(files).then(r => {
          this.uploading = false
          this.$emit('upload', this.target, r.data[0])
        }).catch(() => {
          this.uploading = false
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/adv/TableFileRow.vue